<template>
  <modal-popup-black
    v-show="isShowModalAfterCRMResponse"
    title="Відповідь CRM системи"
    textBtnPrimary="Ok"
    :isShowBtnSecondary="false"
    :textBtnSecondary="''"
    @eventBybtnPrimary="modalOk"
    @eventBybtnSecondary="modalClose"
    @eventBybtnCrissCross="modalCrissCross"
  >
    <template v-slot:content>
      <div class="content">
        {{ $t("profile.modal_crm_response.text") }}
      </div>
    </template>
  </modal-popup-black>
</template>

<script>
  export default {
    emits: ['onClose'],
    props: {
      isShowModal: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        isShowModalAfterCRMResponse: false
      }
    },
    watch: {
      isShowModal: function () {
        this.isShowModalAfterCRMResponse = this.isShowModal
      }
    },
    methods: {
      modalOk () {
        this.modalClose()
      },
      modalCrissCross () {
        this.modalClose()
      },
      modalClose () {
        this.isShowModalAfterCRMResponse = false
        this.$emit('onClose')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// index.vue?8e144d34